import React,{useState,useEffect} from 'react';
import Swal from 'sweetalert2';

import {
Box,
Button,
Paper,
IconButton,
TablePagination,
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
TextField,
Snackbar,
Alert,
Autocomplete,
Typography
} from '@mui/material';

import {Delete, Edit} from "@mui/icons-material";

import AddAndUpDateGrades from "./AddAndUpDateGrades";
import GradesDistributionPdf from "./GradesDistributionPdf";

import api from '../../api/api';
import {useAcademicYear} from '../../AcademicYearContext';



const GradeDistribution = () => {

const token = localStorage.getItem("token");
const {selectedYear} = useAcademicYear();
// USER + TABLE DATA
const [userType,setUserType]=useState("");
const [gradeDistributions,setGradeDistributions]=useState([]);
const [subjects,setSubjects]=useState([]);
const [gradeClasses,setGradeClasses]=useState([]);
const [periods,setPeriods]=useState([]);
const [searchTerm,setSearchTerm]=useState("");
const [totalCount,setTotalCount]=useState(0);
// PDF FILTER STATES
const [pdfGradeClass,setPdfGradeClass]=useState(null);
const [pdfSubject,setPdfSubject]=useState(null);
const [pdfPeriod,setPdfPeriod]=useState(null);
// EDIT CONTROL FOR AddAndUpDateGrades
const [editGradeId,setEditGradeId]=useState(null);
// ALERT STATES
const [snackbarOpen,setSnackbarOpen]=useState(false);
const [alertMessage,setAlertMessage]=useState("");
const [alertSeverity,setAlertSeverity]=useState("success");
// PAGINATION
const [page,setPage]=useState(0);
const [rowsPerPage,setRowsPerPage]=useState(25);

// ===============================
// FETCH USER TYPE
// ===============================
useEffect(()=>{
const fetchUserType=async()=>{
try{
const {data}=await api.get(
"/user-profile/",
{
headers:{
Authorization:`Bearer ${token}`
}
}
);
setUserType(data.user_type);
}catch(error){
console.error(
"User type error:",
error
);
}
};
fetchUserType();
},[]);

// ===============================
// INITIAL DATA FETCHING
// ===============================
useEffect(()=>{
const fetchInitialData=async()=>{
await fetchSubjects();
await fetchGradeClasses();
await fetchPeriods();
if(selectedYear){
await fetchGradeDistributions();
}
};
fetchInitialData();
},[selectedYear]);
// ===============================
// FETCH GRADE DISTRIBUTIONS
// ===============================
const fetchGradeDistributions = async(
pageNumber=1,
pageSize=rowsPerPage,
search=""
)=>{
if(!selectedYear) return;
try{
const params={
academic_year:selectedYear.id,

page:pageNumber,
page_size:pageSize,
search:search
};

const response=await api.get(
"/api/users/grades-distribution/",
{
headers:{
Authorization:`Bearer ${token}`
},
params
}
);

setGradeDistributions(
response.data.results || []
);
setTotalCount(
response.data.count || 0
);
}
catch(error){
console.error(
"Loading grades error:",
error
);
setGradeDistributions([]);
setTotalCount(0);
}};

// ===============================
// LOAD SUBJECTS
// ===============================
const fetchSubjects=async()=>{
try{
const {data}=await api.get(
"/assigned-subjects/",
{
headers:{
Authorization:`Bearer ${token}`
}
}
);
setSubjects(data);
}catch(error){
console.error(
"Subjects error:",
error
);
}
};

// ===============================
// LOAD GRADE CLASSES
// ===============================
const fetchGradeClasses=async()=>{
try{
const {data}=await api.get(
"/assigned-grade-classes/",
{
headers:{
Authorization:`Bearer ${token}`
}

}

);
setGradeClasses(data);
}catch(error){
console.error(
"Grade classes error:",
error
);

}
};
// ===============================
// LOAD PERIODS
// ===============================
const fetchPeriods=async()=>{
try{
const {data}=await api.get(
"/api/users/periods/",
{
headers:{
Authorization:`Bearer ${token}`
}
}
);
setPeriods(data);
}catch(error){
console.error(
"Periods error:",
error
);
}};


// ===============================
// DELETE GRADE DISTRIBUTION
// ===============================
const handleDelete=async(id)=>{

if(userType==="teacher"){
Swal.fire(
"Permission Denied",
"",
"error"
);
return;
}

Swal.fire({
title:"Are you sure?",
icon:"warning",
showCancelButton:true
}).then(async(result)=>{

if(result.isConfirmed){

try{

await api.delete(
`/api/users/grades-distribution/${id}/`,
{
headers:{
Authorization:`Bearer ${token}`
}
}
);

setAlertMessage("Deleted successfully");
setAlertSeverity("success");

fetchGradeDistributions(
page+1,
rowsPerPage,
searchTerm
);

}catch(error){

console.error(error);

setAlertMessage("Delete failed");
setAlertSeverity("error");

}finally{

setSnackbarOpen(true);

}

}

});

};

return(

<Box p={4}>

{/* ===============================
TOP CONTROL AREA
=============================== */}

<Box
sx={{
bgcolor:"#e3f2fd",
p:0.5,
borderRadius:2,
mb:1,
display:"flex",
flexDirection:"column",
gap:2
}}
>

<Typography
variant="h6"
sx={{
fontWeight:"bold"
}}
>
Grade Distribution Records
</Typography>

<Box
display="flex"
flexWrap="wrap"
gap={2}
mb={2}
justifyContent="center"
>

{/* SEARCH */}
<TextField
label="Search Student"
value={searchTerm}
onChange={async(e)=>{

const value=e.target.value;

setSearchTerm(value);
setPage(0);

await fetchGradeDistributions(
1,
rowsPerPage,
value
);

}}
sx={{
width:250
}}
/>

{/* ADD / UPDATE COMPONENT */}
<AddAndUpDateGrades
token={token}
userType={userType}
gradeDistributions={gradeDistributions}
gradeClasses={gradeClasses}
subjects={subjects}
periods={periods}
selectedYear={selectedYear}
editGradeId={editGradeId}
setEditGradeId={setEditGradeId}
page={page}
rowsPerPage={rowsPerPage}
searchTerm={searchTerm}
fetchGradeDistributions={fetchGradeDistributions}
setAlertMessage={setAlertMessage}
setAlertSeverity={setAlertSeverity}
setSnackbarOpen={setSnackbarOpen}
/>

{/* PDF GRADE FILTER */}
<Autocomplete
options={gradeClasses}
getOptionLabel={(option)=>option.name}
value={pdfGradeClass}
onChange={(e,value)=>
setPdfGradeClass(value||null)
}
renderInput={(params)=>
<TextField
{...params}
label="Grade Class"
/>
}
sx={{
width:200
}}
/>

<Autocomplete
options={subjects}
getOptionLabel={(option)=>option.name}
value={pdfSubject}
onChange={(e,value)=>
setPdfSubject(value||null)
}
renderInput={(params)=>
<TextField
{...params}
label="Subject"
/>
}
sx={{
width:200
}}
/>

<Autocomplete
options={periods}
getOptionLabel={(option)=>option.name}
value={pdfPeriod}
onChange={(e,value)=>
setPdfPeriod(value||null)
}
renderInput={(params)=>
<TextField
{...params}
label="Period"
/>
}
sx={{
width:200
}}
/>

{/* PDF COMPONENT */}
<GradesDistributionPdf
pdfGradeClass={pdfGradeClass}
pdfSubject={pdfSubject}
pdfPeriod={pdfPeriod}
selectedYear={selectedYear}
token={token}
setAlertMessage={setAlertMessage}
setAlertSeverity={setAlertSeverity}
setSnackbarOpen={setSnackbarOpen}
/>

<Button
variant="contained"
onClick={()=>{
document
.querySelector("#grades-pdf-download")
.click();
}}
>
Save
</Button>

</Box>

</Box>

{/* ===============================
TABLE AREA START
=============================== */}

<Box
sx={{
bgcolor:"rgb(255, 149, 0)",
p:2,
borderRadius:2,
mb:1
}}
>

<TableContainer component={Paper}>

<Table>

<TableHead>

<TableRow>

{[
"Grade",
"Period",
"Student",
"Subject",
"Quiz",
"Assign",
"Partic.&Attend",
"Test",
"Scale",
"Final",
"Remark",
"Allow Teacher Edit",
"Action"
].map((head)=>(

<TableCell
key={head}
sx={{
backgroundColor:"#0D1B2A",
color:"#fff"
}}
>
{head}
</TableCell>

))}

</TableRow>

</TableHead>

<TableBody>

{gradeDistributions.map((item)=>(

<TableRow
key={item.id}
sx={{
backgroundColor:
userType==="teacher" && item.allow_teacher_update
?
"#E3F2FD"
:
"inherit",
"&:hover":{
backgroundColor:"#f5f5f5"
}
}}
>

<TableCell>{item.grade_class_name}</TableCell>

<TableCell>{item.period_name}</TableCell>

<TableCell>{item.student_name}</TableCell>

<TableCell>{item.subject_name}</TableCell>

<TableCell>{item.quiz_score}</TableCell>

<TableCell>{item.assignment_score}</TableCell>

<TableCell>{item.participation_score}</TableCell>

<TableCell>{item.test_score}</TableCell>

<TableCell>{item.scale_grade}</TableCell>

<TableCell
sx={{
fontWeight:"bold",
color:
(
typeof item.final_score==="number" &&
item.final_score<70
)
||
(
typeof item.final_score==="string" &&
["D","F"].includes(
item.final_score.toUpperCase()
)
)
?
"red"
:
"#0D47A1"
}}
>
{item.final_score}
</TableCell>

<TableCell>
{item.remark}
</TableCell>

{/* ALLOW TEACHER UPDATE */}
<TableCell>

{["admin","vpi","vpa"].includes(userType)

?

<input
type="checkbox"
checked={item.allow_teacher_update}
onChange={async(e)=>{

const value=e.target.checked;

try{

await api.patch(
`/api/users/grades-distribution/${item.id}/`,
{
allow_teacher_update:value
},
{
headers:{
Authorization:`Bearer ${token}`
}
}
);

setGradeDistributions(prev=>
prev.map((grade)=>
grade.id===item.id
?
{
...grade,
allow_teacher_update:value
}
:
grade
)
);

}catch(error){

Swal.fire(
"Error",
"Could not update permission",
"error"
);

}

}}
/>

:

item.allow_teacher_update
?
"Yes"
:
"No"

}

</TableCell>

{/* ACTION BUTTONS */}
<TableCell>

<IconButton
onClick={()=>{
setEditGradeId(item.id);
}}
>
<Edit/>
</IconButton>

<IconButton
onClick={()=>handleDelete(item.id)}
>
<Delete/>
</IconButton>

</TableCell>

</TableRow>

))}

</TableBody>

</Table>

</TableContainer>

{/* ===============================
PAGINATION
=============================== */}

<TablePagination
component="div"
count={totalCount}
rowsPerPage={rowsPerPage}
page={page}
onPageChange={(event,newPage)=>{

setPage(newPage);

fetchGradeDistributions(
newPage+1,
rowsPerPage,
searchTerm
);

}}
onRowsPerPageChange={(event)=>{

const newRows=parseInt(
event.target.value,
10
);

setRowsPerPage(newRows);

setPage(0);

fetchGradeDistributions(
1,
newRows,
searchTerm
);

}}

rowsPerPageOptions={[
5,
10,
25,
50,
100
]}
/>

</Box>

{/* ===============================
SNACKBAR
=============================== */}

<Snackbar
open={snackbarOpen}
autoHideDuration={4000}
onClose={()=>setSnackbarOpen(false)}
>

<Alert
severity={alertSeverity}
>
{alertMessage}
</Alert>

</Snackbar>

</Box>

);

};

export default GradeDistribution;